import type { WUserSettingViewResponse } from '@zola/svc-web-api-ts-client';

import ApiService from '~/util/apiService';

import { UserSettingsObjectType } from '../couples/types/userSettingsActionTypes';

export const loadUserSettings = (keys: string[]): Promise<UserSettingsObjectType> => {
  return ApiService.post<UserSettingsObjectType, { keys: string[] }>(
    '/website-nav/web-api/v1/userSettings/getList',
    { keys }
  );
};

export const recordUserSetting = (key: string) => {
  // the response type is actually WUserSettingViewResponse but WUserSettingView
  // is not correct for the data key there. The data key is the UserSettingView type
  return ApiService.post<WUserSettingViewResponse, { key: string }>(
    '/website-nav/web-api/v1/userSettings/set',
    {
      key,
    }
  );
};
